import { LocalStorage } from './storage';
import { defaultRegisterCodes } from '../constants/registerCodes';

/** Normalize API +register_codes+ (array of { id, register_key, value } or legacy hash) to a key → value map. */
export const registerCodesPayloadToMap = (payload) => {
  if (!payload) {
    return defaultRegisterCodes();
  }
  if (Array.isArray(payload)) {
    return payload.reduce((acc, row) => {
      const key = row.register_key;
      if (key) {
        acc[key] = (row.value ?? '').toString();
      }
      return acc;
    }, defaultRegisterCodes());
  }
  return { ...defaultRegisterCodes(), ...payload };
};

/**
 * Appends " - {code}" when the organization has a non-empty code for +codeKey+.
 * @param {string} text
 * @param {string} codeKey - e.g. raw_material, supply, final_product
 */
export const withRegisterCodeSuffix = (text, codeKey) => {
  if (text === null || text === undefined) {
    return text;
  }
  const base = String(text);
  const codes = registerCodesPayloadToMap(LocalStorage.get('register_codes', {}));
  const value = (codes[codeKey] ?? '').toString().trim();
  if (!value) {
    return base;
  }
  return `${base} - ${value}`;
};
